import React from 'react';
import {makeStyles} from "@material-ui/core/styles";
import Icon from "@material-ui/core/Icon";
import IconButton from "@material-ui/core/IconButton";

const useStyles = makeStyles(theme => ({
    header: {
        width: '64px',
        fontSize: '15px',
        marginBottom: '8px',
        textAlign: 'center',
        overflowWrap: 'break-word'
    },
    button: {
        color: theme.palette.getContrastText(theme.palette.primary.main),
        backgroundColor: theme.palette.primary.main,
        width: '64px',
        height: '64px',
        justifyContent: 'center',
        display: 'center',
        borderRadius: '32px',
        '&:hover': {
            color: theme.palette.getContrastText(theme.palette.primary.main),
            backgroundColor: theme.palette.primary.main
        },
        '&.Mui-disabled': {
            color: theme.palette.getContrastText(theme.palette.primary.main),
            backgroundColor: theme.palette.primary.main + 'aa'
        }
    },
    buttonWithText: {
        fontSize: '12px'
    },
    list: {
        listStyle: 'none',
        padding: 0,
        margin: 0,
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        display: 'flex',
        overflowX: 'auto',
        '& > li': {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            marginLeft: theme.spacing(1),
            marginRight: theme.spacing(1),
            whiteSpace: 'normal'
        }
    }
}))

export const Bubble = ({content, header, onClick, disabled}) => {
    const classes = useStyles();
    return <li className={classes.toolbarContainer}>
        <div className={classes.header}>{header}</div>
        <IconButton className={`${classes.button} ${classes.buttonWithText}`}
                    aria-label="filter" onClick={onClick}
                    disabled={disabled}
        >
            {content}
        </IconButton>
    </li>
}

export const BubbleList = ({children}) => {
    const classes = useStyles();
    return <ul className={classes.list}>
        {children}
    </ul>
}